import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';

const useT = (namespace) => {
  const ns = namespace ? `${namespace}.` : '';
  // next-i18next file name
  const { t } = useTranslation('common');
  return useCallback((key, options = {}) => t(`${ns}${key}`, options), [namespace, t]);
};

export default useT;
